import { render, staticRenderFns } from "./PaySuccess.vue?vue&type=template&id=5c5327e7&scoped=true&"
import script from "./PaySuccess.vue?vue&type=script&lang=js&"
export * from "./PaySuccess.vue?vue&type=script&lang=js&"
import style0 from "./PaySuccess.vue?vue&type=style&index=0&id=5c5327e7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5327e7",
  null
  
)

export default component.exports